import { render, staticRenderFns } from "./log.vue?vue&type=template&id=bc973f32"
import script from "./log.vue?vue&type=script&lang=js"
export * from "./log.vue?vue&type=script&lang=js"
import style0 from "./log.vue?vue&type=style&index=0&id=bc973f32&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc973f32')) {
      api.createRecord('bc973f32', component.options)
    } else {
      api.reload('bc973f32', component.options)
    }
    module.hot.accept("./log.vue?vue&type=template&id=bc973f32", function () {
      api.rerender('bc973f32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/playConfig/templateConfig/log.vue"
export default component.exports